import { 
  ShieldCheck, 
  Bot, 
  Store, 
  Clock, 
  UserCheck, 
  Layers, 
  Sparkles 
} from 'lucide-react';
import { Button } from '../../components/ui/Button.jsx';
import { Badge } from '../../components/ui/Badge.jsx';

export function ExecutiveHeader({
  onNavigate,
  onOpenCopilot,
  lastSyncDate = '21.08.2026, 08:00 CEST',
  roleTitle = 'ASL Betriebsleiter',
}) {
  return (
    <div 
      data-testid="executive-header"
      className="relative rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-xs"
    >
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        {/* Left Welcome Group */}
        <div className="space-y-3 max-w-3xl">
          <div className="flex flex-wrap items-center gap-2.5">
            {/* ASL Ademco Brand Indicator */}
            <div className="flex items-center gap-1.5 rounded-md bg-[var(--primary,#e3000b)] px-2.5 py-1 text-xs font-black uppercase tracking-wider text-white shadow-xs">
              <Layers className="h-3.5 w-3.5" />
              <span>ASL Ademco</span>
            </div>

            {/* Role Badge */}
            <Badge 
              variant="outline"
              className="border-slate-300 bg-slate-50 text-slate-800 text-xs font-bold gap-1 px-2.5 py-1"
            >
              <UserCheck className="h-3.5 w-3.5 text-[var(--primary)]" />
              <span>{roleTitle}</span>
            </Badge>

            {/* System Status Pill */}
            <div data-testid="executive-status-badge" className="inline-flex items-center gap-1.5 rounded-md bg-amber-50 border border-amber-200 px-2.5 py-1 text-xs font-semibold text-amber-900 shadow-2xs">
              <span className="h-2 w-2 rounded-full bg-amber-500" />
              <span>Demo-Vorschau (Nicht verbunden)</span>
            </div>
          </div>

          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-[var(--foreground,#181716)] leading-[1.15]">
              Betriebsleiter Executive Dashboard
            </h1>
            <p className="text-sm text-[var(--secondary,#475569)] mt-1.5 leading-relaxed max-w-3xl">
              Zentrale Übersicht der drei Plattform-Säulen: <span className="font-semibold text-slate-900">White-Label Partner-Shops</span>, <span className="font-semibold text-slate-900">ALWIS technischer Produkt- &amp; Zubehörberater</span> und <span className="font-semibold text-slate-900">RAG-Wissensdatenbank</span> mit Upload-Center.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-4 pt-1 text-xs text-[var(--secondary,#475569)]">
            <div className="flex items-center gap-1.5">
              <Clock className="h-3.5 w-3.5 text-slate-400" />
              <span>Preiskatalog: <strong className="font-mono tabular-nums text-slate-800">{lastSyncDate || 'Demo-Vorschau'}</strong></span>
            </div>
            <span className="text-slate-300">•</span>
            <div className="flex items-center gap-1.5 text-slate-600 font-medium">
              <ShieldCheck className="h-3.5 w-3.5 text-amber-700" />
              <span>Datenschutz-Konzept: Ephemeral RAM / Zero Audio Retention (Vorschau)</span>
            </div>
          </div>
        </div>

        {/* Right CTA Actions */}
        <div className="flex flex-wrap items-center gap-3 shrink-0">
          <Button
            type="button"
            variant="default"
            size="lg"
            data-testid="executive-header-copilot-btn"
            onClick={onOpenCopilot}
            className="h-11 min-h-[44px] gap-2 px-5 font-bold shadow-xs cursor-pointer bg-[var(--primary,#e3000b)] hover:bg-[var(--primary,#e3000b)]/90 text-white focus-visible:ring-2 focus-visible:ring-[var(--primary)] focus-visible:ring-offset-2"
          >
            <Bot className="h-4 w-4" />
            <span>ALWIS Assistent</span>
            <Sparkles className="h-3.5 w-3.5 opacity-80" />
          </Button>

          <Button
            type="button"
            variant="outline"
            size="lg"
            onClick={() => onNavigate && onNavigate('/')}
            className="h-11 min-h-[44px] gap-2 px-4 font-bold border-slate-300 text-[var(--foreground,#181716)] hover:bg-slate-50 cursor-pointer focus-visible:ring-2 focus-visible:ring-[var(--primary)] focus-visible:ring-offset-2"
          >
            <Store className="h-4 w-4 text-[var(--primary,#e3000b)]" />
            <span className="hidden sm:inline">Zum Storefront</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
